import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { TablePagination } from "../models/components/table/table-pagination.model";
import { ParticipantContextProps } from "../models/contexts/participant-context.model";

export const useUpcomingAppointments = (
	participantContext: ParticipantContextProps,
	pagination: TablePagination
) => {
	const participant = participantContext.participant;
	const participantId = participant ? participant.kannactId : null;
	const queryClient = useQueryClient();
	const queryKey = ["upcoming-appointments", { participantId }];
	const query = useQuery({
		queryKey: ["upcoming-appointments", { participantId, pagination }],

		queryFn: async () => {
			if (!participant) return [];
			const ptEmail = participant.emails?.find((x) => x.isPrimary)?.emailAddress;

			return await EndpointsService.appointments.getAppointmentsByParticipant({
				config: {
					params: {
						minDate: null,
						maxDate: null,
						kannactId: participant.kannactId,
						email: ptEmail,
					},
				},
			});
		},

		enabled: !!participant,
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
